module.exports = __webpack_public_path__ + "img/KarpinMobile.3ef9a112.webp";